import React, {memo, ReactNode, useCallback} from 'react';
import {ControlModel, ControlTypeModel} from '../../../types/control';
import {useRPC} from '../../../hooks/rpc';
import {RangeComponent} from '../../Range/RangeComponent';

type Props = {
    control: ControlModel
    controlType: ControlTypeModel;
    children?: ReactNode;
};

export const DimmerControl = memo(function DimmerControl(props: Props) {
    const {control, children, controlType} = props;

    const [rpc] = useRPC();

    const onChange = useCallback((value: number) => {
        rpc.updateControlValue(control.id, value);
    }, [rpc, control.id]);

    return (
        <RangeComponent
            name={control.name}
            value={control.current_value}
            onChange={onChange}
            activeImage={controlType.image_set.active}
            passiveImage={controlType.image_set.passive}>
            {children}
        </RangeComponent>
    );
});
